<template>
    <div>
        <el-button @click="dialogVisible = true" type="danger">交易对批量设置</el-button>


        <el-dialog :visible.sync="dialogVisible" @close="closeDialog" @open="openDialog" title="交易对批量设置" width="1200px">

            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="chexkCode" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="(info,index) in allPair" :label="info" :key="index"
                             style="width: 150px;margin-left: 0px;overflow: hidden;margin-bottom: 5px">{{info}}
                </el-checkbox>
            </el-checkbox-group>

            <div slot="footer" style="text-align: center">
                <div style="margin-bottom: 10px">
                    <el-button type="primary" @click="handleBatchSave(null,true,null)">开启挂买单</el-button>
                    <el-button type="primary" @click="handleBatchSave(null,null,true)">开启挂卖单</el-button>
                    <el-button type="primary" @click="handleBatchSave(true,null,null)">开启交易</el-button>
                </div>
                <div>
                    <el-button @click="handleBatchSave(null,false,null)">关闭挂买单</el-button>
                    <el-button @click="handleBatchSave(null,null,false)">关闭挂卖单</el-button>
                    <el-button @click="handleBatchSave(false,null,null)">关闭交易</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import api from '../../api';

    export default {
        name: 'CurrencyBatch',
        data() {
            return {
                dialogVisible: false,
                checkAll: false,
                isIndeterminate: true,
                chexkCode: [],
                allPair: [],
            };
        },
        methods: {
            closeDialog() {
                this.chexkCode = [];
                this.checkAll = false;
                this.isIndeterminate = true;
                this.dialogVisible = false;
            },
            openDialog() {
                api.getAllPair().then(({data}) => {
                    this.allPair = data;
                });
            },
            handleBatchSave(supportTrade, supportBid, supportAsk) {
                if (this.chexkCode.length <= 0) {
                    this.$message.success('请选择交易对!');
                    return;
                }

                let tipMsg = supportTrade == true ? "确认所选交易对，开启交易" : (supportTrade == false ? "确认所选交易对，关闭交易" :
                    (supportBid == true ? "确认所选交易对，开启挂买单" : (supportBid == false ? "确认所选交易对，关闭挂买单" :
                        (supportAsk == true ? "确认所选交易对，开启挂卖单" : (supportAsk == false ? "确认所选交易对，关闭挂卖单" : "")))));

                this.$confirm(tipMsg, '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateCoinBatch({
                        pairList: this.chexkCode.join(","),
                        supportTrade: supportTrade,
                        supportBid: supportBid,
                        supportAsk: supportAsk
                    }).then(({data}) => {
                        this.$message.success('操作成功!');
                        this.$emit("refresh", {page: 1});
                    });
                }).catch(() => {
                });
            },
            handleCheckAllChange(val) {
                this.chexkCode = val ? this.allPair : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = this.chexkCode.length;
                this.checkAll = checkedCount === this.allPair.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.allPair.length;
            }
        }
    };
</script>

<style lang="less" scoped>
    .url-wrap {
        display: flex;
        align-items: flex-start;
        padding-bottom: 10px;

        .url-text {
            line-height: 40px;
            margin-right: 8px;
        }

        .upload {
            flex: 1;
        }
    }

    .logo {
        display: flex;
        align-items: center;

        .logo-img {
            margin-right: 8px;
            display: inline-block;
            width: 32px;
            height: 32px;
            background-size: 32px;
        }
    }
</style>
